<div class="d-flex flex-row align-items-center header-container">
  <div class="d-flex align-items-center justify-content-center menu-container">
    <div class="hide-mobile">
      @if (hamburgerMenu) {
        <img src="assets/images/ic_menu_white.svg" class="header-hamburger" role="button" tabindex="0"
          (click)="openLeftPanel()" (keydown.enter)="openLeftPanel()" (keydown.space)="openLeftPanel()" alt="Open menu" />
      }
    </div>
    <div class="hide-desktop hide-tablet">
      @if (hamburgerMobileMenu && homePage !== null) {
        @if (hamburgerMobileMenu) {
          <img src="assets/images/ic_previous.svg" class="header-back" role="button" tabindex="0"
            (click)="handleBackButton(backButton)"
            (keydown.enter)="handleBackButton(backButton)"
            (keydown.space)="handleBackButton(backButton)" alt="Back" />
        }
      }
      @if (hamburgerMenu && (homePage || homePage === null)) {
        <img src="assets/images/ic_menu_white.svg" class="header-hamburger" role="button" tabindex="0"
          (click)="openLeftPanel()" (keydown.enter)="openLeftPanel()" (keydown.space)="openLeftPanel()" alt="Open menu" />
      }
    </div>
  </div>
  <span class="flex-grow-1 text-center header-label">{{ appName }}</span>
  <div class="d-flex align-items-center justify-content-center menu-container">
    @if (showHamburgerIcon) {
      <div class="d-flex align-items-center justify-content-center header-badge-container" role="button" tabindex="0"
        (click)="openRightPanel()" (keydown.enter)="openRightPanel()" (keydown.space)="openRightPanel()">
        <div class="d-flex align-items-center justify-content-center header-badge">
          <span class="header-badge-label">{{ initials }}</span>
        </div>
      </div>
    }
  </div>
</div>




<wdpr-pocket-panel #profilePocketPanel id="profilePocketPanel" disable-swipe hide-header align="right">
  <div class="profile" slot="body">
    <div class="profile-wrapper">
      <div class="user-badge">
        <h1>{{user?.nameAbbv}}</h1>
      </div>
      <div class="user-fullname">{{user?.name}}</div>
      <div class="user-hubId">{{user?.hubId}}</div>
      <div class="user-site">{{user?.userProfile?.defaultSiteName}}</div>
      <div class="container" class="role-border">
        <app-expand-collapse class="list-types" id="collapse-roles" [isOpen]="true">
          <ng-container header> {{ 'UserProfile.MyRole' | translate}} </ng-container>
          <ng-container content>
            @if (roles && roles.length) {
              <div class="roles">
                @for (role of roles; track role) {
                  <div>
                    <h1 class="user-role">{{role}}</h1>
                  </div>
                }
              </div>
            } @else {
              <h4><b>{{ 'UserProfile.NoRolesAssigned' | translate}}</b></h4>
            }
          </ng-container>
        </app-expand-collapse>
      </div>
      <div class="container" class="unit-border">
        <span class="unit-title me-2">Measurement Unit</span>
        <select class="unit-select mb-1" (change)="setUnitOfMeasure($event)" [(ngModel)]="preferredUnit">
          @for (unit of unitOfMeasure; track unit) {
            <option>{{unit.text}}</option>
          }
        </select>
      </div>
    </div>
  </div>
  <div slot="footer" name="profile-panel-footer">
    <div class="col-sm-24 col-md-24 col-lg-24 align-items-center">
      <wdpr-button theme="primary" (click)="logout()">{{ 'UserProfile.SignOut' | translate}}</wdpr-button>
    </div>
    <div class="version col-sm-24 col-md-24 col-lg-24">{{ appShortName }} - v{{ appVersion }}</div>
  </div>
</wdpr-pocket-panel>

<wdpr-pocket-panel #sidePocketPanel id="leftProfilePocketPanel" header="{{appShortName}}" disable-swipe align="left"
  (click)="closeSidePocketPanel()">
  <div slot="body">
    <ul class="nav-menu">
      <li><a class="side-link" role="button" tabindex="0"
        (click)="goToHome()" (keydown.enter)="goToHome()" (keydown.space)="goToHome()">Home</a></li>
    </ul>
    @for (tile of tiles; track tile) {
      <ul class="nav-menu">
        <li><a class="side-link" role="button" tabindex="0"
          (click)="goToLink(tile)" (keydown.enter)="goToLink(tile)" (keydown.space)="goToLink(tile)">{{ tile.title }}</a></li>
      </ul>
    }
  </div>
  <slot slot="footer" name="sidebar-panel-footer"></slot>
</wdpr-pocket-panel>

<app-create-cast-member-modal></app-create-cast-member-modal>
<app-create-character-modal [isUpdate]="isUpdate"></app-create-character-modal>
